// extracted by mini-css-extract-plugin
export default {"background":"Signup_background__lNFw7"};